var map = {
	"./music-instructions.json": 4294,
	"./music-library-intro2024.json": 4295,
	"./music-library-launch2024.json": 4296,
	"./music-progression.json": 4297,
	"./startSourcesAdvanced.json": 4298,
	"./startSourcesSimple.json": 4299,
	"./startSourcesSimple2.json": 4300,
	"./startSourcesTracks.json": 4301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4035;